import StorageLocal from "../../../inc/StorageLocal";
import {
    SET_IS_LOAD,
    SET_TITLE,
    SET_AUTH_DATA,
    CLEAR_AUTH_DATA,
    SET_FILTER,
    SET_REFRESH_INTERVAL,
    SET_PAGE_REFRESH_INTERVAL,
    SET_MENU_GROUP_STATE,
} from "./consts";

const initialState = {
    isLoad: false,                // глобальный индикатор загрузки (LinearProgress в шапке)
    title: '',                    // заголовок текущей страницы
    isAuth: false,
    accessToken: null,
    refreshToken: null,
    expAccessToken: null,         // unix-время истечения access-токена
    expRefreshToken: null,
    userPermissions: [],          // список слагов 'admin.<entity>.<slug>' из логина
    userRoles: [],
    user: null,                   // {id, name, email}
    filter: {},                   // общие фильтры списков
    refreshInterval: 0,           // автообновление списков по умолчанию, сек (0 — выкл)
    pageRefreshIntervals: StorageLocal.Get('PAGE_REFRESH_INTERVALS', {}), // {pathname: сек}
    menuGroupsState: {},          // {группа: раскрыта ли}
};

export default function app(state = initialState, action) {
    switch (action.type) {
        case SET_IS_LOAD:
            return { ...state, isLoad: action.payload };
        case SET_TITLE:
            return { ...state, title: action.payload };
        case SET_AUTH_DATA:
            return { ...state, ...action.payload };
        case CLEAR_AUTH_DATA:
            return {
                ...state,
                isAuth: false,
                accessToken: null,
                refreshToken: null,
                expAccessToken: null,
                expRefreshToken: null,
                userPermissions: [],
                userRoles: [],
                user: null,
            };
        case SET_FILTER:
            return { ...state, filter: action.payload };
        case SET_REFRESH_INTERVAL:
            return { ...state, refreshInterval: action.payload };
        case SET_PAGE_REFRESH_INTERVAL:
            return {
                ...state,
                pageRefreshIntervals: {
                    ...state.pageRefreshIntervals,
                    [action.payload.pathname]: action.payload.seconds,
                },
            };
        case SET_MENU_GROUP_STATE:
            return {
                ...state,
                menuGroupsState: {
                    ...state.menuGroupsState,
                    [action.payload.group]: action.payload.isOpen,
                },
            };
        default:
            return state;
    }
}
